export default {"src":"/_next/static/media/emptyContent.ac3d022d.svg","height":202,"width":202,"blurWidth":0,"blurHeight":0};